import { SortItem } from '../../../../app/models/ss-api/responses/member.dashboard.license.response';

export class GUIStatisticsResult {
    ResolvedStartDate: Date;
    ResolvedEndDate: Date;
    Results: GUIStatisticsItemArray;

    public static FixDates(item: GUIStatisticsResult) {
        item.ResolvedStartDate = new Date(item.ResolvedStartDate);
        item.ResolvedEndDate = new Date(item.ResolvedEndDate);
    } 
}

export class GUIStatisticsItem {
    PackageID: Number;
    EventName: String;
    EventCount: Number;
}

export class GUIStatisticsItemArray extends Array<GUIStatisticsItem> {
    public LastSort: SortItem;

    constructor(...items: GUIStatisticsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GUIStatisticsItemArray.prototype);
    }
}
